import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeEquipoRadiologico, setEquipoRadiologico } from "../../../../../../../redux/actions/resolucion";
import EquipoRadiologicoTable from "./table/EquipoRadiologicoTable";
import EquipoRadiologicoTabs from "./tabs/EquipoRadiologicoTabs";

const NewEquipoRadiologicoContainer = ({ handlePreviousStep, setFormPart, stepper }) => {

  const dispatch = useDispatch();
  const equiposRadiologicos = useSelector((state) => state.resolucion.abmSustancia.equiposRadiologicos);

  const [part, setPart] = useState("EquipoRadiologicoTable");

  const handleGoBack = () => {
    handlePreviousStep("Part1");
  };
  const handleNextStep = (step) => {
    setFormPart(step);
  };

  const handleDelete = (rowData) => {
    dispatch(removeEquipoRadiologico(rowData.map((v) => v.index)));
  }

  const handleOpenEquipoRadiologicoTabs = (rowData = {}) => {
    setPart("EquipoRadiologicoTabs");
    dispatch(setEquipoRadiologico(rowData, rowData?.index ?? null));
  };

  return (
    <>
      {
        {
          EquipoRadiologicoTable: (
            <EquipoRadiologicoTable
              handleOpenForm={handleOpenEquipoRadiologicoTabs}
              handleGoBack={handleGoBack}
              handleNextStep={() => handleNextStep("Part3")}
              stepper={stepper}
              data={equiposRadiologicos}
              handleDeleteEquipos={handleDelete}
            />
          ),
          EquipoRadiologicoTabs: (
            <EquipoRadiologicoTabs
              handleGoBack={() => setPart("EquipoRadiologicoTable")}
              stepper={stepper}
            />
          ),
        }[part]
      }
    </>
  );
};

export default NewEquipoRadiologicoContainer;
